import {classNames} from "shared/lib/classNames/classNames";
import cls from "./BenefitsPage.module.scss";
import {ReactNode} from "react";
import {ReactComponent as ExpertiseIcon} from "shared/assets/icons/benefits/Expertise.svg";
import {ReactComponent as InnovationIcon} from "shared/assets/icons/benefits/Innovation.svg";
import {ReactComponent as UserIcon} from "shared/assets/icons/benefits/User.svg";
import {ReactComponent as CustomizationIcon} from "shared/assets/icons/benefits/Customization.svg";
import {ReactComponent as TimelyIcon} from "shared/assets/icons/benefits/Timely.svg";
import {ReactComponent as SupportIcon} from "shared/assets/icons/benefits/Support.svg";
import {ReactComponent as EffectiveIcon} from "shared/assets/icons/benefits/Effective.svg";
import {ReactComponent as CommunicationIcon} from "shared/assets/icons/benefits/Communication.svg";
import Title, {TitleTheme} from "shared/ui/Title/Title";
import Paragraph from "shared/ui/Paragraph/Paragraph";


const BenefitsPage = () => {
    interface Benefit {
        icon: ReactNode;
        title: string;
        text: string;
    }
    const benefits: Benefit[] = [
        {
            icon: <ExpertiseIcon />,
            title: "Expertise",
            text: "Mastery Our crew consists of adept professionals with a demonstrated history of crafting triumphant mobile solutions across diverse sectors."
        },
        {
            icon: <InnovationIcon />,
            title: "Innovation",
            text: "Cutting-Edge Practices We remain at the forefront by ceaselessly investigating and adopting the most recent technologies and development strategies.",
        },
        {
            icon: <UserIcon />,
            title: "User-Centric Approach",
            text: "Client-Focused Philosophy We emphasize user satisfaction in every phase of our creation process, guaranteeing intuitive and captivating applications."
        },
        {
            icon: <CustomizationIcon />,
            title: "Customization",
            text: "Bespoke Solutions Every venture is customized to address the specific requirements and aspirations of our clients, ensuring an ideal match for their corporate objectives."
        },
        {
            icon: <TimelyIcon />,
            title: "Timely Delivery",
            text: "Punctual Execution We commit to rigorous deadlines without compromising excellence, ensuring your application enters the market when you require it."
        },
        {
            icon: <SupportIcon />,
            title: "Ongoing Support",
            text: "Enduring Assistance Our partnership extends beyond the initial release. We offer persistent support and enhancements to maintain your application's peak performance."
        },
        {
            icon: <EffectiveIcon />,
            title: "Cost-Effective Solutions",
            text: "Budget-Friendly Options We present competitive rates without sacrificing quality, delivering exceptional worth for your financial commitment."
        },
        {
            icon: <CommunicationIcon />,
            title: "Transparent Communication",
            text: "Clear Dialogue We sustain accessible channels of communication throughout the development journey, keeping you informed and engaged at each stage."
        },
    ]
    return (
        <div id={"benefitsPage"} className={classNames(cls.BenefitsPage, {}, [])}>
            <section className={classNames("page-section", {}, [])}>
                <div className={classNames("container container__main")}>
                    <div className={cls.BenefitsPage__benefits}>
                        <Title className={cls.BenefitsPage__title} sentences={["What Sets Us Apart?"]} colors={[TitleTheme.NEUTRAL]} />
                        <div className={cls.benefits}>
                            {benefits.map((benefit) => {
                                return (
                                    <div className={classNames(cls.benefits__item, {}, [])}>
                                        <div className={cls.benefits__icon}>
                                            {benefit.icon}
                                        </div>

                                        <div className={cls.benefits__text}>
                                            <div className={cls.benefits__title}>
                                                {benefit.title}
                                            </div>

                                            <Paragraph className={cls.benefits__description}>
                                                {benefit.text}
                                            </Paragraph>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
};

export default BenefitsPage;

